import { Auth } from '@onereach/sdk'
import config from '../config'

export default new Auth({
  logout () {
    const encodedRedirectPath = encodeURIComponent(`${window.location.origin}`)
    window.location = `${config.AUTH_UI_URL}/logout?redirectPath=${encodedRedirectPath}`
  },
  cookieDomain: config.COOKIE_DOMAIN,
  cookiePrefix: config.COOKIE_NAME_PREFIX_NEW,
  authUrl: `${config.SDK_API_URL}/auth/token`,
  allowGuestLogin: Boolean(config.GUEST_LOGIN),
  userCookieName: `${config.COOKIE_NAME_PREFIX}_name`,
  multiUserCookieName: `${config.COOKIE_NAME_PREFIX}_multi`,
  userExpireCookieName: `${config.COOKIE_NAME_PREFIX}_user_expire`,
  expireInLong: `${config.COOKIE_EXPIRATION_LONG}`,
  expireInShort: `${config.COOKIE_EXPIRATION_SHORT}`,
  sdkApiUrl: `${config.SDK_API_URL}`
})
